import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import {useHistory} from 'react-router-dom';

import { Typography } from '@material-ui/core';

import PrimaryButton from 'components/Shared/Buttons/PrimaryButton';

import { updateCandidatesJourneyCompletedSteps } from 'actions/candidateActions';
import { getAgencyId, getCurrentJourneyStepId, getInitialJourneyCompletedStepsIds, getUserId, getAgencyRouteName } from 'reducers';

import { ReactComponent as FinishProfileImage } from 'assets/finish-profile.svg';
import { ReactComponent as ExploreJobsImage } from 'assets/explore-jobs.svg';
import { ReactComponent as FinishProfileImageMobile } from 'assets/finish-profile-mobile.svg';
import { ReactComponent as ExploreJobsImageMobile } from 'assets/explore-jobs-mobile.svg';

import { parseQueryString } from 'utils/helpers';

import { CALENDLY_DIALOG_STATES, substepIds } from 'components/CandidateProfileJourney/CandidateProfileJourneyConstants';

import './CandidatesJourneyNearlyThere.scss';

const Option = ({ imageComponent, text, buttonText, btnOnClick, heading, className }) => {
    return (
        <div className={`cjnt-option ${className ? className : ''}`}>
            <div className="option-image-wrapper">{imageComponent}</div>
            <Typography className="cjnt-option-heading">{heading}</Typography>
            <Typography className="cjnt-option-text">{text}</Typography>
            <PrimaryButton className={'option-btn'} text={buttonText} handleClick={btnOnClick}/>
        </div>
    );
};

const CandidatesJourneyNearlyThere = ({
    handleGoToNextStep,
    stepId,
    completedStepsIds,
    updateCandidatesJourneyCompletedSteps,
    userId,
    agencyId,
    agencyRouteName
}) => {
    const intl = useIntl()
    const history = useHistory();

    const condition = !completedStepsIds.includes(stepId);
    const action = updateCandidatesJourneyCompletedSteps.bind(null, agencyId, userId);

    useEffect(() => {
        const queryString = history.location.search;
        const params = parseQueryString(queryString);
        const isChoiceSectionStepCompleted = completedStepsIds.includes(substepIds.choiseSection);

        if (params.calendlyDialogState === CALENDLY_DIALOG_STATES.OPEN && !isChoiceSectionStepCompleted) {
            goToNextStep();
        }

    }, [history.location.search]);
    
    const goToNextStep = () => {
        handleGoToNextStep(null, condition, action);
    }

    const goToJobsPage = () => {
        const jobPrefix = history.location?.pathname?.includes('create-profile') ? '/create-profile' : '';
        history.push(`/${agencyRouteName}${jobPrefix}/jobs?selectedTab=Recommended`);
    }

    return (
        <div className="candidates-nearly-there-wrapper">
            <div className="candidates-nearly-there-container">
                <div className="text-container">
                    <Typography className="heading">{intl.formatMessage({ id: "you-are-nearly-there-title" })}</Typography>
                    <Typography className="text-container-text">
                        {intl.formatMessage({ id: "you-are-nearly-there-subtitle-one" })}
                    </Typography>
                    <Typography className="text-container-text">
                        {intl.formatMessage({ id: "you-are-nearly-there-subtitle-two" })}
                    </Typography>
                </div>
                <div className="cjnt-options-container">
                    <Option
                        className={'finish-profile-option'}
                        imageComponent={isMobile ? <FinishProfileImageMobile /> : <FinishProfileImage />}
                        buttonText={intl.formatMessage({ id: "continue" })}
                        btnOnClick={goToNextStep}
                        heading={intl.formatMessage({ id: "finish-profile" })}
                        text={intl.formatMessage({ id: "finish-profile-text" })}
                    />
                    <Option
                        className={'explore-jobs-option'}
                        imageComponent={isMobile ? <ExploreJobsImageMobile /> : <ExploreJobsImage />}
                        buttonText={intl.formatMessage({ id: "browse" })}
                        btnOnClick={goToJobsPage}
                        heading={intl.formatMessage({ id: "explore-jobs" })}
                        text={intl.formatMessage({ id: "explore-jobs-text" })}
                    />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    stepId: getCurrentJourneyStepId(state),
    completedStepsIds: getInitialJourneyCompletedStepsIds(state),
    agencyId: getAgencyId(state),
    userId: getUserId(state),
    agencyRouteName: getAgencyRouteName(state),
});

const mapDispatchToProps = {
    updateCandidatesJourneyCompletedSteps,
};

export default connect(mapStateToProps, mapDispatchToProps)(CandidatesJourneyNearlyThere);
